import { Expose } from 'class-transformer';

export class ModelCreditCard {
    @Expose()
    id?: string;

    @Expose()
    cardNumber?: string;

    @Expose()
    cardType?: string;

    @Expose()
    cardTypeShorten?: string;

    @Expose()
    cardHolder?: string;

    @Expose()
    cardExpiration?: string;

    @Expose()
    cardCvc?: string;

    @Expose()
    singleUseCustomerToken?: string;

    @Expose()
    paymentTokenFrom?: string;

    @Expose()
    state?: string;

    @Expose()
    zip?: string;

    @Expose()
    dateOfBirth?: string;
}
